<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div>
      <span>Home</span>
      <h2 class="ui primary header">Create an Account</h2>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="10px"></div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="50px">
    <div fxFlex="grow">
      <div appMargin marginB="20px" class="text">
        Please provide your most recent IRR Number below to proceed
      </div>
      <div demo class="ui info message">
        <img src="assets/icons/icon9.svg" alt="" />
        <p>
          Please make use of the <span>Reference Number</span> on your Interim
          Registration Report (<span>IRR</span>) Certificate
        </p>
      </div>
      <div
        class="ui form"
        [formGroup]="detailForm"
        [ngClass]="{ loading: pending }"
      >
        <div class="field required">
          <label>Input IRR Number</label>
          <small
            >Please enter only numbers, other characters are not allowed
          </small>
          <input
            formControlName="irrNumber"
            type="text"
            name="irrNumber"
            style="margin-top: 4px"
            placeholder="e.g. 1234567"
          />
        </div>
      </div>
      <div
        class="ui tertiary segment no-border"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngIf="error"
        style="margin-bottom: 60px"
      >
        <div fxFlex="7%">
          <img src="assets/images/caution.svg" alt="exclamation icon" />
        </div>
        <div fxFlex class="msg">
          We have a problem getting the details of your IRR,
          <span>
            <a
              class="link"
              routerLink="/home-page/sign-up/step2"
              [queryParams]="{ source: 'procurement', token: token }"
            >
              click here
            </a>
          </span>
          to enter your RC number and Tax Identification number (TIN) to
          proceed.
        </div>
      </div>

      <div
        class="ui box segment"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        id="section"
      >
        <div fxFlex (click)="goBack()">
          <i class="arrow left colored primary icon"></i>
        </div>
        <div>
          <button class="ui primary button" (click)="submitForm()">
            Proceed
          </button>
        </div>
      </div>
    </div>

    <div
      fxFlex="35%"
      fxHide.lt-sm="true"
      appPadding
      paddingT="0"
      fxLayout="column"
      class="ui vertical basic segment"
      [ngClass]="{ loading: mpending }"
    >
      <div class="side" appPadding="7">
        <div [innerHtml]="registrationSidebar"></div>
      </div>
    </div>
  </div>
</div>
